

<custom-select          #levelManager  
                        [values]        =   "levels"
                        title_multiple  =   "custom.levels.title"
                        autoSelectFirst =   "true"
                        class           =   "mr-3"></custom-select>

<br class="date-separator">

<mat-form-field         floatLabel      =   "always" 
                        appearance      =   "outline"
                        class           =   "mr-3">
  <mat-label translate>
    pages.statistics.fields.date_from.label
  </mat-label>
  <input                  matInput 
                          [matDatepicker] = "from"
                          [(ngModel)]     = "dateFrom"
                          [max]           = "dateTo"
                          readonly        = "readonly"
                          (click)         = "from.open()">
  <mat-datepicker-toggle  matSuffix 
                          [for]="from">
  </mat-datepicker-toggle>
  <mat-datepicker         #from></mat-datepicker>

</mat-form-field>

<mat-form-field         floatLabel      =   "always" 
                        appearance      =   "outline"
                        class           =   "mr-3">
  <mat-label translate>
    pages.statistics.fields.date_to.label
  </mat-label>
  <input                  matInput 
                          [matDatepicker] = "to"
                          [(ngModel)]     = "dateTo"
                          [min]           = "dateFrom"
                          [max]           = "maxDate" 
                          readonly        = "readonly"
                          (click)         = "to.open()">
  <mat-datepicker-toggle  matSuffix 
                          [for]="to">
  </mat-datepicker-toggle>
  <mat-datepicker         #to></mat-datepicker>
</mat-form-field>


<br>

<custom-select          #analisyManager  
                        [values]        =   "analisy"
                        title_multiple  =   "custom.analisy.title"
                        autoSelectFirst =   "true"
                        class           =   "mr-3"></custom-select>


<organization-select    #orgManager
                        [hidden]        =   "!showOrganizations()"
                        autoSelectFirst =   "true"
                        class           =   "mr-3"></organization-select>                        

<site-select            #siteManager
                        [hidden]        =   "!showSites()"
                        [org]           =   "orgManager?.currentValue"
                        autoSelectFirst =   "true"
                        class           =   "mr-3"></site-select>

<button                 type="submit" 
                        mat-raised-button 
                        [hidden]        =   "showDetailTotal()"
                        (click)="getStatistics()"
                        class="rounded-lg py-1 pl-bgc align-super mr-3" >
  <span class="font-weight-bold s-tc" translate>
    pages.statistics.get_statistic
  </span>
</button>

<custom-select          #detailTotalManager  
                        [hidden]        =   "!showDetailTotal()"
                        [values]        =   "detailTotal"
                        title_multiple  =   "custom.tipology.title"
                        autoSelectFirst =   "true"
                        class           =   "mr-3"></custom-select>

<button                 type="submit" 
                        mat-raised-button 
                        [hidden]        =   "!showDetailTotal() || showServiceCounter()"
                        (click)="getStatistics()"
                        class="rounded-lg py-1 pl-bgc align-super mr-3" >
  <span class="font-weight-bold s-tc" translate>
    pages.statistics.get_statistic
  </span>
</button>

<br>

<custom-select          #serviceCounterManager  
                        [hidden]        =   "!showServiceCounter()"
                        [values]        =   "serviceCounter"
                        title_multiple  =   "custom.servicecounter.title"
                        autoSelectFirst =   "true"
                        class           =   "mr-3"></custom-select>

<service-select         #serviceManager
                        [hidden]        =   "!showService()"
                        [site]           =  "siteManager?.currentValue"
                        autoSelectFirst =   "true"
                        [all]           =   "all"
                        class           =   "mr-3"></service-select>

<device-select          #deviceManager
                        [hidden]        =   "!showDevice()"
                        [site]          =   "siteManager?.currentValue"
                        autoSelectFirst =   "true"
                        type            =   "20"
                        class           =   "mr-3"></device-select>

<button                 type="submit" 
                        mat-raised-button 
                        [hidden]          =   "!showServiceCounter()"
                        (click)="getStatistics()"
                        class="rounded-lg py-1 pl-bgc align-super mr-3" >
  <span class="font-weight-bold s-tc" translate>
    pages.statistics.get_statistic
  </span>
</button>

<help-alert 
            text        = "help.page.statistic.field"
            action      = "help.page.statistic.action" 
            info        = "help.info"
            description = "help.page.statistic.description">
</help-alert>

<br>
<br>

<custom-table           #statisticTable
                        table_id            =   "statisticTable"
                        title_single        =   "tables.statistics.title"
                        title_multiple      =   "tables.statistics.title"
                        filter_title        =   "tables.statistics.filter_title"
                        no_filter_row       =   "true"
                        [columns]           =   "statisticsColumns"
                        [header_buttons]    =   "header_buttons"
                        [values]            =   "statistics"
                        [chartsConf]        =   "chartsConf"
                        [groups]            =   "groups"></custom-table>

                        <!-- <custom-table           #statisticTable
                        table_id            =   "statisticTable"
                        title_single        =   "tables.statistics.title"
                        title_multiple      =   "tables.statistics.title"
                        filter_title        =   "tables.statistics.filter_title"
                        search_title        =   "tables.statistics.search_title"
                        [columns]           =   "statisticsColumns"
                        [header_buttons]    =   "header_buttons"
                        [values]            =   "statistics"
                        [chartsConf]        =   "chartsConf"></custom-table> -->